import ContestCard from './ContestCard';

export default ContestCard;